var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcFiledownloadOff = function SvgIcFiledownloadOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5c-.9 0-1.7.3-2.4.7l6.2 6.2c.5-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5zM7.5 12c0 2.5 2 4.5 4.5 4.5.9 0 1.7-.3 2.4-.7L8.2 9.6c-.4.7-.7 1.5-.7 2.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3.9 17.2.8C16.6.3 15.8 0 15 0H4.3c-1 0-1.8.8-1.8 1.8v20.3c0 1 .8 1.8 1.8 1.8h15.4c1 0 1.8-.8 1.8-1.8V6.3c.1-.9-.3-1.7-1-2.4zM12 18.4c-3.5 0-6.4-2.9-6.4-6.4 0-3.5 2.9-6.4 6.4-6.4 3.5 0 6.4 2.9 6.4 6.4 0 3.5-2.9 6.4-6.4 6.4z"
  })));
};
export default SvgIcFiledownloadOff;